/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CoreBaseService } from '../core-base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { CoreStrictHttpResponse } from '../core-strict-http-response';

import { CoreStandardTaskResponseDto } from '../models/core-standard-task-response-dto';
import { standardTasksControllerAddSubtask } from '../fn/standard-tasks/standard-tasks-controller-add-subtask';
import { StandardTasksControllerAddSubtask$Params } from '../fn/standard-tasks/standard-tasks-controller-add-subtask';
import { standardTasksControllerCreate } from '../fn/standard-tasks/standard-tasks-controller-create';
import { StandardTasksControllerCreate$Params } from '../fn/standard-tasks/standard-tasks-controller-create';
import { standardTasksControllerFindAllByTenant } from '../fn/standard-tasks/standard-tasks-controller-find-all-by-tenant';
import { StandardTasksControllerFindAllByTenant$Params } from '../fn/standard-tasks/standard-tasks-controller-find-all-by-tenant';
import { standardTasksControllerFindOne } from '../fn/standard-tasks/standard-tasks-controller-find-one';
import { StandardTasksControllerFindOne$Params } from '../fn/standard-tasks/standard-tasks-controller-find-one';
import { standardTasksControllerRemove } from '../fn/standard-tasks/standard-tasks-controller-remove';
import { StandardTasksControllerRemove$Params } from '../fn/standard-tasks/standard-tasks-controller-remove';
import { standardTasksControllerRemoveSubtask } from '../fn/standard-tasks/standard-tasks-controller-remove-subtask';
import { StandardTasksControllerRemoveSubtask$Params } from '../fn/standard-tasks/standard-tasks-controller-remove-subtask';
import { standardTasksControllerUpdate } from '../fn/standard-tasks/standard-tasks-controller-update';
import { StandardTasksControllerUpdate$Params } from '../fn/standard-tasks/standard-tasks-controller-update';
import { standardTasksControllerUpdateSubtask } from '../fn/standard-tasks/standard-tasks-controller-update-subtask';
import { StandardTasksControllerUpdateSubtask$Params } from '../fn/standard-tasks/standard-tasks-controller-update-subtask';

@Injectable({ providedIn: 'root' })
export class CoreStandardTasksService extends CoreBaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `standardTasksControllerFindAllByTenant()` */
  static readonly StandardTasksControllerFindAllByTenantPath = '/o2-core/standard-tasks/{tenant}';

  /**
   * Retrieve standard tasks by tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `standardTasksControllerFindAllByTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardTasksControllerFindAllByTenant$Response(params: StandardTasksControllerFindAllByTenant$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreStandardTaskResponseDto>>> {
    const obs = standardTasksControllerFindAllByTenant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve standard tasks by tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `standardTasksControllerFindAllByTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardTasksControllerFindAllByTenant(params: StandardTasksControllerFindAllByTenant$Params, context?: HttpContext): Observable<Array<CoreStandardTaskResponseDto>> {
    const resp = this.standardTasksControllerFindAllByTenant$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreStandardTaskResponseDto>>): Array<CoreStandardTaskResponseDto> => r.body)
    );
  }

  /** Path part for operation `standardTasksControllerCreate()` */
  static readonly StandardTasksControllerCreatePath = '/o2-core/standard-tasks/{tenant}';

  /**
   * Create a new standard task.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `standardTasksControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  standardTasksControllerCreate$Response(params: StandardTasksControllerCreate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreStandardTaskResponseDto>> {
    const obs = standardTasksControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new standard task.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `standardTasksControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  standardTasksControllerCreate(params: StandardTasksControllerCreate$Params, context?: HttpContext): Observable<CoreStandardTaskResponseDto> {
    const resp = this.standardTasksControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreStandardTaskResponseDto>): CoreStandardTaskResponseDto => r.body)
    );
  }

  /** Path part for operation `standardTasksControllerFindOne()` */
  static readonly StandardTasksControllerFindOnePath = '/o2-core/standard-tasks/{tenant}/id/{id}';

  /**
   * Retrieve a standard task by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `standardTasksControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardTasksControllerFindOne$Response(params: StandardTasksControllerFindOne$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreStandardTaskResponseDto>> {
    const obs = standardTasksControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a standard task by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `standardTasksControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardTasksControllerFindOne(params: StandardTasksControllerFindOne$Params, context?: HttpContext): Observable<CoreStandardTaskResponseDto> {
    const resp = this.standardTasksControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreStandardTaskResponseDto>): CoreStandardTaskResponseDto => r.body)
    );
  }

  /** Path part for operation `standardTasksControllerRemove()` */
  static readonly StandardTasksControllerRemovePath = '/o2-core/standard-tasks/{tenant}/{id}';

  /**
   * Delete a standard task by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `standardTasksControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardTasksControllerRemove$Response(params: StandardTasksControllerRemove$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreStandardTaskResponseDto>> {
    const obs = standardTasksControllerRemove(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a standard task by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `standardTasksControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardTasksControllerRemove(params: StandardTasksControllerRemove$Params, context?: HttpContext): Observable<CoreStandardTaskResponseDto> {
    const resp = this.standardTasksControllerRemove$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreStandardTaskResponseDto>): CoreStandardTaskResponseDto => r.body)
    );
  }

  /** Path part for operation `standardTasksControllerUpdate()` */
  static readonly StandardTasksControllerUpdatePath = '/o2-core/standard-tasks/{tenant}/{id}';

  /**
   * Update a standard task by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `standardTasksControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  standardTasksControllerUpdate$Response(params: StandardTasksControllerUpdate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreStandardTaskResponseDto>> {
    const obs = standardTasksControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a standard task by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `standardTasksControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  standardTasksControllerUpdate(params: StandardTasksControllerUpdate$Params, context?: HttpContext): Observable<CoreStandardTaskResponseDto> {
    const resp = this.standardTasksControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreStandardTaskResponseDto>): CoreStandardTaskResponseDto => r.body)
    );
  }

  /** Path part for operation `standardTasksControllerAddSubtask()` */
  static readonly StandardTasksControllerAddSubtaskPath = '/o2-core/standard-tasks/{tenant}/{id}/subtasks';

  /**
   * Add a subtask to a standard task.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `standardTasksControllerAddSubtask()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  standardTasksControllerAddSubtask$Response(params: StandardTasksControllerAddSubtask$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreStandardTaskResponseDto>> {
    const obs = standardTasksControllerAddSubtask(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add a subtask to a standard task.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `standardTasksControllerAddSubtask$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  standardTasksControllerAddSubtask(params: StandardTasksControllerAddSubtask$Params, context?: HttpContext): Observable<CoreStandardTaskResponseDto> {
    const resp = this.standardTasksControllerAddSubtask$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreStandardTaskResponseDto>): CoreStandardTaskResponseDto => r.body)
    );
  }

  /** Path part for operation `standardTasksControllerRemoveSubtask()` */
  static readonly StandardTasksControllerRemoveSubtaskPath = '/o2-core/standard-tasks/{tenant}/{id}/subtasks/{subtaskCode}';

  /**
   * Remove a subtask from a standard task by code.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `standardTasksControllerRemoveSubtask()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardTasksControllerRemoveSubtask$Response(params: StandardTasksControllerRemoveSubtask$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreStandardTaskResponseDto>> {
    const obs = standardTasksControllerRemoveSubtask(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Remove a subtask from a standard task by code.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `standardTasksControllerRemoveSubtask$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  standardTasksControllerRemoveSubtask(params: StandardTasksControllerRemoveSubtask$Params, context?: HttpContext): Observable<CoreStandardTaskResponseDto> {
    const resp = this.standardTasksControllerRemoveSubtask$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreStandardTaskResponseDto>): CoreStandardTaskResponseDto => r.body)
    );
  }

  /** Path part for operation `standardTasksControllerUpdateSubtask()` */
  static readonly StandardTasksControllerUpdateSubtaskPath = '/o2-core/standard-tasks/{tenant}/{id}/subtasks/{subtaskCode}';

  /**
   * Update a subtask in a standard task by code.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `standardTasksControllerUpdateSubtask()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  standardTasksControllerUpdateSubtask$Response(params: StandardTasksControllerUpdateSubtask$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreStandardTaskResponseDto>> {
    const obs = standardTasksControllerUpdateSubtask(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a subtask in a standard task by code.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `standardTasksControllerUpdateSubtask$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  standardTasksControllerUpdateSubtask(params: StandardTasksControllerUpdateSubtask$Params, context?: HttpContext): Observable<CoreStandardTaskResponseDto> {
    const resp = this.standardTasksControllerUpdateSubtask$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreStandardTaskResponseDto>): CoreStandardTaskResponseDto => r.body)
    );
  }

}
